<template>
  <div
    class="toolbar-wrap flex"
    :class="{
      disabled: !onlineStatus,
      'disabled gray-out': pageArchived,
    }"
  >
    <div
      ref="toolbarWrap"
      class="toolbar-sections-wrap flex flex-row flex-wrap"
    >
      <MenuSection
        :editor="editor"
        :commands="undoRedoCommands"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import MenuSection from '@/components/editor/toolbar/MenuSection';
import { undoRedoCommands } from '@/components/editor/toolbar/selection';

const props = defineProps({
  editorId: {
    type: String,
    required: true,
    default: '',
  },
  pageArchived: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const store = useStore();
const hideTimeout = ref(null);

const onlineStatus = computed(() => store.getters.getOnline);
const editor = computed(() => store.getters.editor(props.editorId) || {});

onBeforeUnmount(() => {
  if (hideTimeout.value) {
    clearTimeout(hideTimeout.value);
  }
});
</script>
